import React, { PureComponent } from "react";
import { fieldGenerator } from "utilities/form";
import { OrderedMap, Map } from "immutable";
import { INPUT_TYPES } from "constants/index";
import PropTypes from "prop-types";
import { DocumentViewer } from "components/index";
import { Table, Icon, Form, Card, Button, Checkbox, Badge, message, Modal, Select } from "antd";
import _trim from "lodash/trim";
import CompanyLosService from "../services/company-los-services";
import { REJECT_REASONS } from 'constants/index';
import { formatIndianCurrency, parseIndianCurrency } from "utilities/currency";

class CompanyInvoiceFormList extends PureComponent {
    state = {
        currentImageIndex: 0,
        checkedInvoiceIds: [],
        allChecked: false,
        buyerGstin: {},
        anchorList: [],
        dealerCodeListData: [],
        currentPage: 1,
        pageSize: 20,
        showRejectModal: false,
        selectedRejectReason: null,
        rejectInvoiceId: null,
        rejectLoader: false,

    };

    componentDidMount() {
        let fieldObj = {};
        if (this.props.dealerCodes && this.props.dealerCodes.data && this.props.dealerCodes.data.length) {
            this.props.dealerCodes.data.map(_ => fieldObj[_.gstin] = { dealer_codes: _.dealer_codes, display_name: _.display_name });
            this.setState({
                buyerGstin: fieldObj,
                dealerCodeListData: this.props.dealerCodes?.data
            }, () => {
                this.setSelectedFields();
            });
        } else {
            if (this.props.values.toJS()[0]?.seller_gstin) {
                CompanyLosService.getDealers(this.props.values.toJS()[0]?.seller_gstin).then((data) => {
                    data.data.map(_ => fieldObj[_.gstin] = { dealer_codes: _.dealer_codes, display_name: _.display_name });
                    this.setState({
                        buyerGstin: fieldObj,
                        dealerCodeListData: data?.data
                    }, () => {
                        this.setSelectedFields();
                    });
                }).catch((err) => {
                    console.error("---> ", err);
                });

                // CompanyLosService.getSellerWiseAnchorList(this.props.values.toJS()[0]?.seller_gstin).then((data) => {
                //     this.setState({
                //         anchorList: data.data
                //     });
                // }).catch((err) => {
                //     console.error("---> ", err);
                // });
            }
        }
    }

    setSelectedFields = () => {
        const { buyerGstin } = this.state;
        this.props.values.map((_, k) => {
            this.props.form.setFieldsValue({
                [`[${k}].buyer_name_display`]: buyerGstin[_.buyer_gstin] ? _.buyer_gstin : "",
            });
        });
    }

    amountChange = (_, val) => {
        this.props.form.setFieldsValue({
            [`[${_}].amount`]: val,
            [`[${_}].principal_amount`]: val
        });
    }

    getFormFields = (principal_amount_validator) => {
        return new OrderedMap({
            "file_url": {
                labelProp: "file_url",
                className: "d-none",
                category: 1
            },
            "file_name": {
                labelProp: "file_name",
                className: "d-none",
                category: 1
            },
            "file_size": {
                labelProp: "file_size",
                className: "d-none",
                category: 1
            },
            "id": {
                labelProp: "id",
                className: "d-none",
                category: 1
            },
            "is_verified": {
                labelProp: "is_verified",
                className: "d-none",
                category: 1
            },
            "invoice_no": {
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0 w-100",
                placeholder: "Invoice no.",
                showSearch: true,
                labelProp: "invoice_no",
                rules: [
                    {
                        required: true,
                        message: "invoice no is required"
                    }
                ],
                label: "Invoice no",
                category: 2,
                size: "small",

            },
            "invoice_date": {
                type: INPUT_TYPES.DATE,
                className: "form-field mr-10 mb-0 w-100",
                placeholder: "(YYYY-MM-DD)",
                showSearch: true,
                labelProp: "invoice_date",
                rules: [
                    {
                        required: true,
                        message: "invoice date is required"
                    }
                ],
                label: "Invoice date",
                category: 2,
                // size: "small",

            },
            "amount": {
                type: INPUT_TYPES.NUMBER,
                className: "form-field mr-10 mb-0",
                placeholder: "Invoice amount",
                labelProp: "amount",
                formatter: formatIndianCurrency,
                parser: parseIndianCurrency,
                rules: [
                    {
                        required: true,
                        message: "invoice amount is required"
                    }
                ],
                label: "Invoice amount",
                category: 3,
                // size: "small",

            },
            "principal_amount": {
                type: INPUT_TYPES.NUMBER,
                className: "form-field mr-10 mb-0",
                placeholder: "Principal amount",
                labelProp: "principal_amount",
                formatter: formatIndianCurrency,
                parser: parseIndianCurrency,
                rules: [
                    {
                        required: true,
                        message: "funded amount is required",
                    },
                    principal_amount_validator
                ],
                label: "Principal amount",
                category: 3,

            },
            "buyer_name_display": {
                type: INPUT_TYPES.SELECT,
                label: "Buyer Name",
                className: "form-field mr-10 mb-0 equalWidthCol ",
                showSearch: true,
                placeholder: "Buyer",
                options: [],
                rules: [],
                category: 5,
                filterOption: (inputValue, option) => {
                    if (option.props.children.toLowerCase().includes(inputValue.toLowerCase())) {
                        return true;
                    }
                },
                allowClear: "false"
            },
            "buyer_gstin": {
                labelProp: "buyer_gstin",
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0 equalWidthCol",
                placeholder: "buyer GSTIN",
                rules: [
                    {
                        required: true,
                        message: "buyer gstin is required",
                    }
                ],
                onChange: this.onBuyerGstin,
                label: "Buyer GSTIN",
                category: 5,
                size: "small",

            },
            "dealer_code": {
                type: INPUT_TYPES.SELECT,
                className: "form-field mr-10 mb-0 flex-1",
                style: {
                    minWidth: "auto",
                    maxWidth: 266
                },
                placeholder: "Dealer Code",
                rules: [],
                options: [],
                label: "Dealer Code",
                category: 4,
            },
            "primary_brands": {
                labelProp: "primary_brands",
                type: INPUT_TYPES.SELECT,
                className: "form-field mr-10 mb-0",
                mode: "single",
                options: [],
                rules: [
                    {
                        required: true,
                        message: "primary brand is required",
                    }
                ],
                disabled: true,
                label: "Primary Brands",
                size: "small",

            },
            "cases": {
                labelProp: "cases",
                type: INPUT_TYPES.SELECT,
                className: "form-field mr-10 mb-0",
                mode: "multiple",
                options: [],
                disabled: true,
                label: "Cases",
                size: "small",

            },
            "seller_gstin": {
                labelProp: "seller_gstin",
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0",
                placeholder: "seller GSTIN",
                disabled: true,
                label: "Seller GSTIN",
                category: 4,
                size: "small",
            },
            // "anchor_gstin": {
            //     labelProp: "anchor_gstin",
            //     type: INPUT_TYPES.SELECT,
            //     className: "form-field mr-10 mb-0",
            //     options: [],
            //     rules: [
            //         {
            //             required: true,
            //             message: "anchor is required"
            //         }
            //     ],
            //     disabled: true,
            //     label: "Anchor",
            //     size: "small",

            // },
            "tenor": {
                labelProp: "tenor",
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0",
                placeholder: "Tenor",
                label: "Tenor",
                category: 6,
                size: "small",
                rules: [
                    {
                        required: true,
                        message: "Tenor is required"
                    },
                ],
            },
            "invoice_tenure": {
                labelProp: "invoice_tenure",
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0",
                placeholder: "Invoice Tenure",
                disabled: true,
                label: "Invoice Tenure",
                category: 4,
                size: "small",
            },
            "invoice_roi": {
                labelProp: "invoice_roi",
                type: INPUT_TYPES.TEXT,
                className: "form-field mr-10 mb-0",
                placeholder: "Invoice ROI",
                disabled: true,
                label: "Invoice ROI",
                category: 4,
                size: "small",
            },
        });
    }

    formFields = () => this.getFormFields(
        {
            validator: (rules, value, callback) => {
                const amountVal = Object.values(this.props.form.getFieldsValue()).find(el => el.principal_amount == value).amount;
                if ((Number(value) > Number(amountVal)) || Number(value) <= 0 || Number(amountVal) <= 0) {
                    console.log("inside validation");
                    // callback("Disbursal amount cannot be greater than Invoice amount");
                    // const amount = (this.props.form.getFieldValue([`[${_}].amount`]) || {}).amount;
                    // if (value > amount) {
                    //     callback("Disbursal amount cannot be greater than Invoice amount");
                } else {
                    callback();
                }
            }
        }
    );
    fieldGenerator = fieldGenerator.bind(this.props.form);

    getCheckedFieldNames = () => {
        const allFieldsValue = this.props.form.getFieldsValue();
        const checkedFieldNames = [];
        Object.keys(allFieldsValue).forEach(idx => {
            const row = allFieldsValue[idx];
            if (row && this.state.checkedInvoiceIds.includes(row.id)) {
                Object.keys(row).forEach(fieldName => {
                    checkedFieldNames.push(`[${idx}].${fieldName}`);
                });
            }
        });
        return checkedFieldNames;
    }

    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            const validateArgs = this.props.isChecker
                ? [this.getCheckedFieldNames()]
                : [];
            if (this.props.isChecker && !validateArgs[0].length) {
                return;
            }
            this.props.form.validateFields(...validateArgs, (err, data) => {
                if (this.props.isChecker) {
                    if (!err) {
                        let isFinalSubmit = false;
                        if (Object.values(data).find(el => Number(el.tenor) < 15 || Number(el.tenor) > 90)) {
                            message.error("Please enter correct tenor");
                            return;
                        }
                        const resolvedInvoices = this.props.values.filter(_ =>
                            _.is_verified ||
                            _.invoice_status === "rejected" ||
                            this.state.checkedInvoiceIds.includes(_.id)).size;
                        if (resolvedInvoices === this.props.values.size) {
                            isFinalSubmit = true;
                        }
                        this.props.invoiceValuesSubmit(new OrderedMap(data).map(_ =>
                            _
                        )
                            .toList()
                            .toArray()
                            .filter(_ =>
                                this.state.checkedInvoiceIds.includes(_.id))
                            .map(_ => {
                                if (!this.checkBuyerNameSelected(_.buyer_name_display)) {
                                    delete (_.buyer_name_display);
                                } else {
                                    _.buyer_name_display = this.state.buyerGstin[_.buyer_name_display].display_name;
                                }
                                delete (_.buyer_name);
                                if (!_.dealer_code) {
                                    delete (_.dealer_code);
                                }
                                return ({
                                    ..._,
                                    is_verified: true,
                                    invoice_no: _trim(_.invoice_no, " "),
                                    amount: Number(_.amount),
                                    principal_amount: Number(_.principal_amount),
                                    seller_gstin: _trim(_.seller_gstin, " "),
                                    buyer_gstin: _trim(_.buyer_gstin, " "),
                                    anchor_gstin: _.primary_brands
                                });
                            }), isFinalSubmit);
                        this.setState({
                            checkedInvoiceIds: []
                        });
                    }
                } else {
                    if (!err) {
                        this.props.invoiceValuesSubmit(new OrderedMap(data).map(_ =>
                            _
                        ).toList().toArray().map(_ => {
                            if (!this.checkBuyerNameSelected(_.buyer_name_display)) {
                                delete (_.buyer_name_display);
                            } else {
                                _.buyer_name_display = this.state.buyerGstin[_.buyer_name_display].display_name;
                            }
                            delete (_.buyer_name);

                            if (!_.dealer_code) {
                                delete (_.dealer_code);
                            }
                            return ({
                                ..._,
                                invoice_no: _trim(_.invoice_no, " "),
                                amount: Number(_.amount),
                                principal_amount: Number(_.principal_amount),
                                seller_gstin: _trim(_.seller_gstin, " "),
                                buyer_gstin: _trim(_.buyer_gstin, " "),
                                anchor_gstin: _.primary_brands
                            });
                        }));
                        // this.props.finalSubmission("maker");
                    }
                }
            });
        }
    };

    checkBuyerNameSelected = (buyer_display_name) => {
        if (!buyer_display_name || !this.state.buyerGstin[buyer_display_name]) return false;
        return true;
    }

    getRemainingInvoicesFromForm = (formData, excludedInvoiceId) => {
        const byId = {};
        this.props.values.forEach(inv => {
            const row = typeof inv.toJS === "function" ? inv.toJS() : inv;
            if (row && row.id != null) {
                byId[row.id] = row;
            }
        });
        return new OrderedMap(formData)
            .mapEntries(([, v]) => ([v.id, v]))
            .filter((_, k) => k !== excludedInvoiceId)
            .toList()
            .map(v => ({ ...byId[v.id], ...v }))
            .toArray();
    };

    onRemove = invoiceId => {
        this.props.form.validateFields((err, data) => {
            if (err) {
                return;
            }
            this.props.onRemove(invoiceId, this.getRemainingInvoicesFromForm(data, invoiceId));
        });
    }

    selectImageIndex = _ => {
        this.setState({
            currentImageIndex: _
        });
    }

    getSelectableInvoiceIds = () =>
        this.props.values
            .filter(_ => _.invoice_status === "pending" && !_.is_verified)
            .map(_ => _.id)
            .toJS();

    checkAll = () => {
        if (this.state.allChecked) {
            this.setState({
                checkedInvoiceIds: [],
                allChecked: false
            });
        } else {
            this.setState({
                allChecked: true,
                checkedInvoiceIds: this.getSelectableInvoiceIds()
            });
        }
    }

    getTotalInvoiceAmount = () => {
        const initialAmount = (this.props.values || []).reduce((agg, val) => {
            return agg + +val?.principal_amount;
        }, 0);
        const totalAmount = new OrderedMap(this.props.form.getFieldsValue()).map(_ => _).toList().toArray().reduce((agg, val) => {
            return agg + +val?.principal_amount;
        }, 0);
        return totalAmount || initialAmount || 0;
    }

    getSelectedInoiceAmount = () => {
        const initialAmount = (Object.values(this.props.form?.getFieldsValue()).filter(_ => this.state.checkedInvoiceIds.includes(_.id)) || []).reduce((agg, val) => {
            return agg + +val.principal_amount;
        }, 0);
        return initialAmount;
    }

    renderHeader = () => {
        const pendingInvoices = this.props.values.filter(_ => _.invoice_status === "pending").size > 0;
        const selectableCount = this.getSelectableInvoiceIds().length;
        return (
            <div className={"d-flex flex-row justify-content-space-between"}>
                <div className={"d-flex flex-row align-items-center"}>
                    {(this.props.isChecker && this.props.values.size !== this.props.values.filter(_ => _.is_verified).size) &&
                        pendingInvoices &&
                        <Checkbox
                            className={"mr-5"}
                            // indeterminate={this.state.checkedInvoiceIds.length}
                            onChange={this.checkAll}
                            checked={selectableCount > 0 && this.state.checkedInvoiceIds.length === selectableCount}
                        >All</Checkbox>
                    }
                    <div className={"d-flex flex-column"}>
                        <span>Total - {this.props.values.size} invoices of ₹{this.getTotalInvoiceAmount()}</span>
                        <span>Selected - {this.state.checkedInvoiceIds.length} invoices of ₹{this.getSelectedInoiceAmount()}</span>
                    </div>
                </div>
                <div
                    className={
                        "pb-10 d-flex justify-content-flex-end"
                    }>
                    {this.props.isEditable && pendingInvoices && <Button disabled={this.isApprovedDisabled()} type="primary" htmlType={"submit"}>
                        {this.props.loading ? (
                            <Icon type={"loading"} />
                        ) : null}
                        {this.props.isChecker ? "Approve" : "Submit"}
                    </Button>}
                </div>
            </div>
        );
    };
    getFormFiels = (updatedFormData, _, data, item) => {
        let fields = this.formFields(null);
        let bizongoGSTIN = "27AAVCS6045D1Z0";
        if (updatedFormData[data]) {
            let inputGstin = updatedFormData[data].buyer_gstin && updatedFormData[data].buyer_gstin.toUpperCase();
            if (this.state.buyerGstin[inputGstin] && !this.state.buyerGstin[inputGstin].dealer_codes.length) {
                fields = fields.delete("dealer_code");
            }
            if (item["program_anchor_gstin"] == null || (Object.values(updatedFormData)[0] && (item["program_anchor_gstin"] !== bizongoGSTIN || this.props.history?.location?.state?.tenorOnUpload))) {
                fields = fields.delete("tenor");
            }
        }
        return fields;
    }

    onBuyerGstChange = (_, e) => {
        const { buyerGstin } = this.state;
        let input = e.target.value.toUpperCase();
        let updatedFormData = this.props.form.getFieldsValue();
        if (updatedFormData[_] && buyerGstin[input]) {
            this.props.form.getFieldDecorator([`[${_}].buyer_name_display`]);
            this.props.form.setFieldsValue({
                [`[${_}].dealer_code`]: this.state.buyerGstin[e.target.value]?.dealer_codes[0],
                [`[${_}].buyer_name_display`]: input
            });
        } else {
            this.props.form.setFieldsValue({
                [`[${_}].dealer_code`]: "",
                [`[${_}].buyer_name_display`]: "GSTIN not linked"
            });
        }
    }

    selectBuyer = (buyer, item) => {
        let updatedFormData = this.props.form.getFieldsValue();
        let data = Object.keys(updatedFormData).filter(_ => updatedFormData[_].id === item.id);

        if (updatedFormData[data]) {
            this.props.form.setFieldsValue({
                [`[${data}].dealer_code`]: "",
                [`[${data}].buyer_gstin`]: buyer,
                [`[${data}].buyer_name_display`]: buyer
            });
        } else {
            this.props.form.setFieldsValue({
                [`[${data}].dealer_code`]: "",
                [`[${data}].buyer_name_display`]: "GSTIN not linked"
            });
        }
    }


    renderForm = (item, _) => {
        let updatedFormData = this.props.form.getFieldsValue();
        let data = Object.keys(updatedFormData).filter(_ => updatedFormData[_]?.id === item?.id);
        const fieldsVal = this.props.values && this.props.values.toJS()[0] && this.props.values.toJS()[0].comparative_data;
        const fieldsObj = {
            "invoice_no": "invoice_no",
            "invoice_date": "invoice_date",
            "amount": "invoice_amount",
            "principal_amount": "invoice_amount",
            "buyer_gstin": "buyer_gstin",
        };
        return (
            <div className={"w-100"}>{
                this.getFormFiels(updatedFormData, _, data, item)
                    .groupBy(__ => __.category)
                    .map((__, category) => {
                        if (category !== 1) {
                            return (<div className={"w-100 d-flex justify-content-flex-start mb-5"} offset={(category === 3 || category === 4) ? 1 : 0} key={category}>
                                {__.map((field, fieldName) => {
                                    if ((fieldsVal && Object.keys(fieldsVal).length > 0 && fieldsObj && fieldsObj[fieldName])) {
                                        field.helpMessage = fieldsObj && fieldsObj[fieldName] && fieldsVal[fieldsObj[fieldName]] && fieldsVal[fieldsObj[fieldName]].is_edited_by_maker && "Edited by seller";
                                        field.className = field.className + fieldsObj && fieldsObj[fieldName] && fieldsVal[fieldsObj[fieldName]] && fieldsVal[fieldsObj[fieldName]].is_edited_by_maker && " invoiceFieldColor";
                                    }
                                    if (fieldName === "principal_amount") {
                                        let filteredArray = Object.values(updatedFormData).filter(el => el.principal_amount > el.amount);
                                        let filteredArrayNonPositives = Object.values(updatedFormData).filter(el => el.principal_amount <= 0);
                                        if (filteredArray.length > 0 && filteredArray.find(el => Number(el.principal_amount) > Number(el.amount) && el.id == item?.id)) {
                                            field.helpMessage = "Principal amount cannot be greater than Invoice amount";
                                        }
                                        if (filteredArrayNonPositives.length > 0 && filteredArrayNonPositives.find(el => Number(el.principal_amount) <= 0 && el.id == item?.id)) {
                                            field.helpMessage = "Principal amount cannot be <= 0";
                                        }
                                    }
                                    if (fieldName === "amount") {
                                        let filteredArray = Object.values(updatedFormData).filter(el => el.amount <= 0);
                                        if (filteredArray.length > 0 && filteredArray.find(el => Number(el.amount) <= 0 && el.id == item?.id)) {
                                            field.helpMessage = "Invoice amount cannot be <= 0";
                                        }
                                    }
                                    if (fieldName === "tenor") {
                                        let filteredArray = Object.values(updatedFormData).filter(el => Number(el.tenor) < 15 || Number(el.tenor) > 90);
                                        if (filteredArray.length > 0 && filteredArray.find(el => (Number(el.tenor) < 15 || Number(el.tenor) > 90) && el.id == item?.id)) {
                                            field.helpMessage = "Tenor should be between 15 and 90";
                                        }
                                    }
                                    if (fieldName === "dealer") {
                                        field.onSearch = this.onDealerSearch;
                                        field.onSelect = this.setDealer;
                                        field.disabled = item.is_verified || this.props.values.size === this.props.values.filter(_ => _.is_verified).size || !this.props.isEditable;
                                    } else if (fieldName === "seller_gstin") {
                                        field.disabled = true;
                                    } else if (fieldName === "dealer_code") {
                                        if (updatedFormData[data]) {
                                            let currentGstin = updatedFormData[data].buyer_gstin && updatedFormData[data].buyer_gstin.toUpperCase();
                                            field.options = this.state.buyerGstin[currentGstin] ? this.state.buyerGstin[currentGstin].dealer_codes.map(_ => ({
                                                label: _,
                                                value: _
                                            })) : [];
                                            // field.rules = [
                                            //     {
                                            //         required: true,
                                            //         message: "Dealer Code is required"
                                            //     },
                                            // ];
                                            field.disabled = item.is_verified || this.props.values.size === this.props.values.filter(_ => _.is_verified).size || !this.props.isEditable;
                                        }
                                    } else {
                                        field.disabled = item.is_verified || this.props.values.size === this.props.values.filter(_ => _.is_verified).size || !this.props.isEditable;
                                    }

                                    if (fieldName === "buyer_name_display") {
                                        if (updatedFormData[data]) {
                                            field.options = Map(this.state.buyerGstin).map((_, k) => ({
                                                label: _.display_name,
                                                value: k
                                            })).toList().toJS();
                                            field.onSelect = (buyer) => this.selectBuyer(buyer, item);
                                        }
                                    }
                                    if (fieldName === "buyer_gstin") {
                                        field.onChange = this.onBuyerGstChange.bind(null, _);
                                    }
                                    if (fieldName === "primary_brands") {
                                        let filterdAnchorlist = this.state.dealerCodeListData?.filter((item) => item.gstin == updatedFormData[data]?.buyer_gstin) && this.state.dealerCodeListData?.filter((item) => item.gstin == updatedFormData[data]?.buyer_gstin).length && this.state.dealerCodeListData?.filter((item) => item.gstin == updatedFormData[data]?.buyer_gstin)[0];

                                        field.options = filterdAnchorlist?.anchor_list && filterdAnchorlist?.anchor_list?.length > 0 && filterdAnchorlist?.anchor_list?.map(_ => ({
                                            label: _.name,
                                            value: _.gstin
                                        }))
                                    }
                                    if (fieldName === "amount") {
                                        field.onChange = this.amountChange.bind(null, _);
                                    }
                                    return this.fieldGenerator(`[${_}].${fieldName}`, field)();
                                }).toList()}
                            </div>);
                        } else {
                            return (
                                <div className={"w-100"} key={category}>
                                    {__.map((field, fieldName) => {
                                        if (fieldName === "dealer") {
                                            field.onSearch = this.onDealerSearch;
                                            field.onSelect = this.setDealer;
                                            field.disabled = item.is_verified || this.props.values.size === this.props.values.filter(_ => _.is_verified).size || !this.props.isEditable;
                                        } else if (fieldName === "seller_gstin") {
                                            field.disabled = true;
                                        } else {
                                            field.disabled = item.is_verified || this.props.values.size === this.props.values.filter(_ => _.is_verified).size || !this.props.isEditable;
                                        }
                                        return this.fieldGenerator(`[${_}].${fieldName}`, field)();
                                    }).toList()}
                                </div>
                            );
                        }
                    })
                    .toList()}
            </div>);
    };

    checkCheckBox = _ => {
        if (this.state.checkedInvoiceIds.includes(_)) {
            this.setState({
                checkedInvoiceIds: this.state.checkedInvoiceIds.filter(id => id !== _)
            });
        } else {
            this.setState({
                checkedInvoiceIds: [...this.state.checkedInvoiceIds, _]
            });
        }
    }
    statusMap = {
        auto_approved: "Auto Approved",
        manual_approved: "Manual Approved",
        rejected: "Rejected",
        pending: "Pending",
    }

    openRejectModal = invoiceId => {
        this.setState({
            showRejectModal: true,
            rejectInvoiceId: invoiceId,
            selectedRejectReason: null,
        });
    };

    submitReject = () => {
        const { rejectInvoiceId, selectedRejectReason } = this.state;
        if (!rejectInvoiceId || selectedRejectReason === null) {
            return;
        }
        this.setState({ rejectLoader: true });
        this.props.form.validateFields((err, data) => {
            if (err) {
                this.setState({ rejectLoader: false });
                return;
            }
            this.props.onRemove(
                rejectInvoiceId,
                this.getRemainingInvoicesFromForm(data, rejectInvoiceId),
                selectedRejectReason
            );
            this.setState({
                rejectLoader: false,
                showRejectModal: false,
                selectedRejectReason: null,
                rejectInvoiceId: null,
            });
        });
    };

    closeRejectModal = () => {
        this.setState({
            showRejectModal: false,
            selectedRejectReason: null,
            rejectInvoiceId: null,
        });
    };


    isApprovedDisabled = () => {
        if (this.props.isChecker) {
            return this.state.checkedInvoiceIds.length === 0;
        }
        return false;
    }

    // onApprove = () => {

    // }

    render() {
        const invoiceList = this.props.values.toJS();
        const { currentPage, pageSize } = this.state;
        const pageStartIndex = (currentPage - 1) * pageSize;
        const pageEndIndex = pageStartIndex + pageSize;
        const pagedInvoices = invoiceList.slice(pageStartIndex, pageEndIndex);
        const invoiceRows = pagedInvoices.map((item, index) => ({
            ...item,
            __index: pageStartIndex + index
        }));
        const invoiceColumns = [
            {
                title: "Select",
                key: "select",
                width: 80,
                render: (_, record) =>
                    (this.props.isChecker && !record.is_verified && record.invoice_status === "pending") ? (
                        <Checkbox
                            disabled={record.is_verified}
                            onChange={() => this.checkCheckBox(record.id)}
                            checked={record.is_verified || this.state.checkedInvoiceIds.includes(record.id)}
                        />
                    ) : null
            },
            {
                title: "File",
                dataIndex: "file_name",
                key: "file_name",
                render: (_, record) => (
                    <div className={"d-flex align-items-center"}>
                        <Icon
                            style={{ fontSize: "20px", color: "#08c", marginRight: "8px" }}
                            theme="outlined"
                            type={"file-pdf"}
                        />
                        <span>{record.file_name}</span>
                    </div>
                )
            },
            {
                title: "Status",
                dataIndex: "invoice_status",
                key: "invoice_status",
                width: 140,
                render: (_, record) =>
                    this.props.isChecker ? (
                        <Badge
                            style={{ backgroundColor: `${record.invoice_status === "rejected" ? "red" : "#52c41a"}` }}
                            count={this.statusMap[record.invoice_status] || "--"}
                        />
                    ) : "--"
            },
            {
                title: "Actions",
                key: "actions",
                width: 100,
                align: "center",
                render: (_, record) =>
                    this.props.isChecker &&
                        !record.is_verified &&
                        record.invoice_status === "pending" ? (
                        <Button
                            type="link"
                            style={{ color: "#f5222d", padding: 0 }}
                            onClick={e => {
                                e.stopPropagation();
                                this.openRejectModal(record.id);
                            }}
                        >
                            Reject
                        </Button>
                    ) : null
            }
        ];
        return (
            <>
                <Modal
                    visible={this.state.showRejectModal}
                    title="Reject Invoice"
                    onCancel={this.closeRejectModal}
                    footer={[
                        <Button key="cancel" onClick={this.closeRejectModal}>
                            Cancel
                        </Button>,
                        <Button
                            key="submit"
                            type="primary"
                            loading={this.state.rejectLoader}
                            disabled={this.state.selectedRejectReason === null}
                            onClick={this.submitReject}
                        >
                            Submit
                        </Button>,
                    ]}
                >
                    <Select
                        style={{ width: "100%" }}
                        placeholder="Select reject reason"
                        value={this.state.selectedRejectReason}
                        onChange={value => this.setState({ selectedRejectReason: value })}
                    >
                        {Array.from(REJECT_REASONS.entries()).map(([label, value]) => (
                            <Select.Option key={value} value={value}>
                                {label}
                            </Select.Option>
                        ))}
                    </Select>
                </Modal>

                <Form onSubmit={this.onValuesSubmit}>
                    <Form.Item className={"mb-10 invoice-list-form"}>
                        <div
                            className={"ph-20 d-flex justify-content-space-between"}>
                            <div className={"fb-40 border-none"}>
                                {this.renderHeader()}
                                <Table
                                    bordered
                                    size={"middle"}
                                    rowKey={"id"}
                                    dataSource={invoiceRows}
                                    columns={invoiceColumns}
                                    pagination={{
                                        current: currentPage,
                                        pageSize,
                                        total: invoiceList.length,
                                        showSizeChanger: true,
                                        pageSizeOptions: ["10", "20", "50", "100"],
                                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} invoices`,
                                        onChange: (page, nextPageSize) => {
                                            this.setState({
                                                currentPage: page,
                                                pageSize: nextPageSize
                                            });
                                        },
                                        onShowSizeChange: (page, nextPageSize) => {
                                            this.setState({
                                                currentPage: page,
                                                pageSize: nextPageSize
                                            });
                                        }
                                    }}
                                    onRow={(record) => ({
                                        onClick: () => this.selectImageIndex(record.__index)
                                    })}
                                    rowClassName={record => record.__index === this.state.currentImageIndex ? "ant-table-row-selected" : ""}
                                    expandedRowRender={record => (
                                        <div className={"form-row w-100 fb-100 d-flex flex-column"}>
                                            <div style={{ display: "flex", gap: "12px", marginBottom: "14px" }}>
                                                <div style={{ background: "#f5f5f5", border: "1px solid #e8e8e8", borderRadius: "6px", padding: "6px 14px", flex: 1, wordBreak: "break-word" }}>
                                                    <div style={{ fontSize: "11px", color: "#8c8c8c", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: "3px" }}>Construction Site</div>
                                                    <div style={{ fontWeight: 500, color: "#262626", fontSize: "13px" }}>{record.construction_site || "-"}</div>
                                                </div>
                                                <div style={{ background: "#f5f5f5", border: "1px solid #e8e8e8", borderRadius: "6px", padding: "6px 14px", minWidth: "160px" }}>
                                                    <div style={{ fontSize: "11px", color: "#8c8c8c", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: "3px" }}>Business Product Type</div>
                                                    <div style={{ fontWeight: 500, color: "#262626", fontSize: "13px" }}>{record.business_product_type || "-"}</div>
                                                </div>
                                            </div>
                                            <div className={"d-flex flex-row align-items-center"}>
                                                {this.renderForm(record, record.__index)}
                                            </div>
                                        </div>
                                    )}
                                    defaultExpandAllRows
                                />
                            </div>
                            <div className={"fb-60 pl-10"}>
                                <Card
                                    className={
                                        "no-shadow border-none top-0 pos-sticky"
                                    }
                                    bordered={false}>
                                    <DocumentViewer
                                        // key={_.id}
                                        width={"100%"}
                                        height={600}
                                        isInvoice={true}
                                        url={
                                            this.props.values.getIn([this.state.currentImageIndex, "file_url"])
                                        }
                                    />
                                </Card>
                            </div>
                        </div>
                    </Form.Item>
                </Form>
            </>
        );
    }
}


CompanyInvoiceFormList.propTypes = {
    form: PropTypes.object,
    values: PropTypes.object,
    loading: PropTypes.bool,
    toggleModal: PropTypes.func,
    isChecker: PropTypes.bool,
    invoiceValuesSubmit: PropTypes.func,
    isEditable: PropTypes.bool,
    finalSubmission: PropTypes.func,
    onRemove: PropTypes.func,
    dealerCodes: PropTypes.object,
    history: PropTypes.object,
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
            values
                .map(val => {
                    return new OrderedMap(val).set("principal_amount", val.principal_amount || val.amount)
                        .map((value) =>
                            Form.createFormField({
                                value
                            })
                        );
                })
                .toJS();
    }
})(CompanyInvoiceFormList);